export const STEP_ONE = 'STEP_ONE';
export const STEP_TWO = 'STEP_TWO';
export const RESET = 'RESET';